module.exports = __webpack_public_path__ + "static/media/icon_decline.636eadf5.svg";